import React from 'react';
import PropTypes from 'prop-types';
import Component from 'BaseComponent';

export default class Form extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    onSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
  }

  static defaultProps = {
    error: null,
  }

  render() {
    const { error, children, onSubmit } = this.props;

    return (
      <form onSubmit={onSubmit}>
        {
          error &&
            <div className="form__global-error">
              {this.t(error.error, error.meta)}
            </div>
        }
        {children}
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./app/form/Form.jsx